import { useMemo } from "react";
import { useLocation } from "react-router-dom";

// Маппинг маршрутов на русские названия
const BREADCRUMB_LABELS = {
  "/dashboard": "Главная",
  "/finance": "Баланс",
  "/orders": "Заказы",
  "/new-order": "Новый заказ",
  "/order-details": "Оформление заказа",
  "/profile/payments": "Финансы",
  "/notifications": "Уведомления",
  "/settings": "Настройки",
  "/admin/menu-history": "История меню",
  "/admin/menu-history/:menuId": "Детали меню",
  "/admin/dish-management": "Управление блюдами",
  "/admin/nutrition-data": "Сводные данные",
  "/admin/new-menu": "Новое меню",
  "/canteen-week-orders": "Заказы питания",
  "/student-balances": "Балансы учеников",
  "/support": "Поддержка",
  "/tutor-list": "Мой класс",
  "/tutor/class-orders": "Заказы класса",
  "/tutor/student-orders": "Заказы ученика",
};

export const useBreadcrumb = () => {
  const location = useLocation();

  const breadcrumbs = useMemo(() => {
    // Если мы на главной странице, не показываем хлебные крошки
    if (location.pathname === "/dashboard") {
      return [];
    }

    const paths = location.pathname.split("/").filter(Boolean);

    const crumbs = [
      {
        label: "🏠 Главная",
        path: "/dashboard",
        current: false,
      },
    ];

    let currentPath = "";
    paths.forEach((path, index) => {
      currentPath += `/${path}`;

      // Проверяем точное совпадение
      let label = BREADCRUMB_LABELS[currentPath];

      // Если не найдено, проверяем паттерны с ID
      if (!label) {
        if (
          currentPath.includes("/admin/menu-history/") &&
          path.match(/^[a-f0-9-]+$/)
        ) {
          label = "Детали меню";
        } else {
          label = BREADCRUMB_LABELS[`/admin/${path}`] || formatPath(path);
        }
      }

      crumbs.push({
        label,
        path: currentPath,
        current: currentPath === location.pathname,
      });
    });

    return crumbs;
  }, [location.pathname]);

  return breadcrumbs;
};

const formatPath = (path) => {
  // Если не нашли маппинг, не возвращаем английский текст
  return "Раздел";
};
